import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { MyharrellsService } from '../myharrells.service';
import e from 'express';
import { MyharrellsloginpromptComponent } from "../myharrellsloginprompt/myharrellsloginprompt.component";

@Component({
  selector: 'app-search',
  standalone: true,
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
  imports: [CommonModule, FormsModule, MyharrellsloginpromptComponent]
})
export class SearchComponent {

  constructor(private title: Title, private meta: Meta, public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  resourceImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Resources/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";
  educationImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Education/";
  productPhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/ProductPhotos/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";
  imagePaths: string = environment.appDomainURL + environment.baseImagesFilePathBlobStorage + "/";
  imageExists: boolean = false;

  productsExpanded: boolean = true;

  displayFailureAlert: boolean = false;
  sdsNotice: boolean = false;
  labelNotice: boolean = false;
  sdsNoticeModal: boolean = false;
  labelNoticeModal: boolean = false;
  metalNoticeModal: boolean = false;

  isHovered: boolean = false;

  failureText: string = "";

  searchResults: any[] = [];
  productResults: any[] = [];
  empResults: any[] = [];
  blogResults: any[] = [];
  invoiceResults: any[] = [];
  educationResults: any[] = [];

  searchSubmitted: boolean = false;

  loggedInUser: any = null;
  isAdmin: boolean = false;

  productsSDS: string = "SEARCH FOR SDS";
  productsLabel: string = "SEARCH FOR LABEL";
  productsMetal: string = "SEARCH FOR METAL";

  skuNumber: string = "";


  ngOnInit() {

    //meta tags for SEO
    this.title.setTitle("meta title tag description here-  search");
    this.meta.updateTag({ name: 'description', content: "meta tag description here -  search" });
    this.meta.updateTag({ property: 'og:title', content: "og title here -  search" });
    this.meta.updateTag({ property: 'og:description', content: "og:description here -  search" });
    this.meta.updateTag({ property: 'og:image', content: "og:image here -  search" });
    this.meta.updateTag({ property: 'og:url', content: "og:url here -  search" });
    this.meta.updateTag({ property: 'Twitter:card', content: "twitter:card here -  search" });
    this.meta.updateTag({ property: 'Twitter:site', content: "twitter:site here -  search" });
    this.meta.updateTag({ property: 'Twitter:title', content: "twitter:title here -  search" });
    this.meta.updateTag({ property: 'Twitter:description', content: "twitter:description here -  search" });
    this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here -  search" });


    if (this.dotComService.searchTerm != "") {
      this.SearchFired();
    }




  }

  SearchFired() {
    this.dotComService.ShowSpinnerModal();
    this.searchResults = [];
    this.productResults = [];
    this.empResults = [];
    this.blogResults = [];
    this.invoiceResults = [];
    this.educationResults = [];

    this.displayFailureAlert = false;
    this.sdsNotice = false;
    this.labelNotice = false;
    this.sdsNoticeModal = false;
    this.labelNoticeModal = false;
    this.metalNoticeModal = false;
    this.failureText = "";
    this.searchSubmitted = false;

    if (this.dotComService.searchTerm.trim().length > 2) {
      //check if user is logged into myharrells.  if so they also search for their 
      //customers invoices 
      this.loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));
      if (this.loggedInUser == null) {
        this.loggedInUser = "";
      }
      else {
        //check if user is an admin 
        this.isAdmin = (this.loggedInUser && this.loggedInUser.RoleName.indexOf('HarrellsAdmin') > -1)
      }

      this.dotComService.GetSiteSearch('full', this.dotComService.searchTerm, this.loggedInUser.Email, this.isAdmin).subscribe(data => {
        this.searchResults = data;

        //now checking for search results from the matrix system for education posts logged there
        let matrixPostsForSearch = this.myHarrellsService.matrixCourseList.filter(x => x.name.indexOf('pond') > -1 || x.short_description.indexOf('pond') > -1)
        if (matrixPostsForSearch.length > 0) {
          for (let i = 0; i < matrixPostsForSearch.length; i++) {
            let element = matrixPostsForSearch[i];

            const month = String(new Date(element.metadata.created_at).getMonth() + 1);
            const day = String(new Date(element.metadata.created_at).getDate());
            const year = new Date(element.metadata.created_at).getFullYear();
            element.RevisionPublishDate = month + '/' + day + '/' + year;

            element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');

            // //categories 
            // if (element.tags.filter(ii => ii.indexOf('cat-') > -1).length > 0) {
            //   //element.Categories = element.tags.filter(ii => ii.indexOf('cat-') > -1).map(ii => ii.replace('cat-', ''));
            // }

            data.push({
              IsMatrixPost: true,
              Id: element.id, //used to forward to the matrix post 
              SearchResultType: "ed",
              WebName: element.name,
              Name: element.name,
              RevisionPublishDate: element.RevisionPublishDate,
              RevisionPublishDateSort: element.RevisionPublishDateSort,
              Category: element.Categories,
              PostSummary: element.short_description,
              Title: element.name,
              LoggedInUserName: element.organization_name,
            });
          }
        }

        this.dotComService.HideSpinnerModal()

        if (this.searchResults.length == 0) {
          this.searchSubmitted = true;
        }

        //PRODUCTS DATA IF ANY 
        this.productResults = data.filter(x => x.SearchResultType == "p");
        for (let i = 0; i < this.productResults.length; i++) {
          this.productResults[i].ImageURL = this.productPhotosImagePaths + this.productResults[i].ItemNmbr + ".jpg"
        }
        this.productResults = this.productResults.sort((a, b) => (a.WebName < b.NamWebNamee) ? -1 : 1)


        //EMPLOYEES DATA IF ANY
        this.empResults = [];
        let empResultsFilter = data.filter(x => x.SearchResultType == "e");

        //check if employee photo exists
        for (let index = 0; index < empResultsFilter.length; index++) {
          const element = empResultsFilter[index];
          let imgToUse = "";
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              imgToUse = this.employeePhotosImagePaths + element.Id + ".jpg";
              this.empResults.push({ Email: element.Email, Name: element.Name, ImgURL: imgToUse, Title: element.Title, Phone: element.Phone, Id: element.Id })
              this.empResults = this.empResults.sort((a, b) => (a.Name < b.Name) ? -1 : 1)
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  imgToUse = this.employeePhotosImagePaths + element.Id + ".png";
                  this.empResults.push({ Email: element.Email, Name: element.Name, ImgURL: imgToUse, Title: element.Title, Phone: element.Phone, Id: element.Id })
                  this.empResults = this.empResults.sort((a, b) => (a.Name < b.Name) ? -1 : 1)
                } else {
                  // Fail code - use default
                  imgToUse = this.baseImagePaths + "harrellsh.png"
                  this.empResults.push({ Email: element.Email, Name: element.Name, ImgURL: imgToUse, Title: element.Title, Phone: element.Phone, Id: element.Id })
                  this.empResults = this.empResults.sort((a, b) => (a.Name < b.Name) ? -1 : 1)
                }
              })
            }
          });
        }

        //BLOGS DATA IF ANY 
        let blogResultsFiltered = data.filter(x => x.SearchResultType == "b");

        for (let i = 0; i < blogResultsFiltered.length; i++) {
          let element = blogResultsFiltered[i];
          element.RevisionPublishDate = element.RevisionPublishDate.substring(0, element.RevisionPublishDate.indexOf(' ')).replace('1/1/9999', '');

          element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');

          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.blogImagePaths + element.WebName + ".jpg", (exists) => {
            if (exists) {
              // Success code
              element.ImageName = this.blogImagePaths + element.WebName + ".jpg"
              this.blogResults.push(element);
              this.blogResults = this.blogResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.blogImagePaths + element.WebName + ".png", (exists) => {
                if (exists) {
                  // Success code
                  element.ImageName = this.blogImagePaths + element.WebName + ".png"
                  this.blogResults.push(element);
                  this.blogResults = this.blogResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                } else {
                  // Fail code - use default
                  element.ImageName = this.baseImagePaths + "harrellsh.png"
                  this.blogResults.push(element);
                  this.blogResults = this.blogResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                }
              })
            }
          });

        }

        //INVOICES DATA IF ANY AND IF USER IS LOGGED IN 
        this.invoiceResults = [];
        let invoiceResultsFiltered = data.filter(x => x.SearchResultType == "iv");

        for (let i = 0; i < invoiceResultsFiltered.length; i++) {
          let element = invoiceResultsFiltered[i];
          element.DocumentDate = element.DocumentDate.substring(0, element.DocumentDate.indexOf(' ')).replace('1/1/9999', '');
          element.ImageName = this.baseImagePaths + "InvHistoryIcon.png"
          this.invoiceResults.push(element);
          if (i == invoiceResultsFiltered.length - 1) {
            this.invoiceResults = this.invoiceResults.sort((a, b) => (a.DocumentDate < b.DocumentDate) ? 1 : -1)
          }
        }

        //EDUCATION DATA IF ANY 
        let educationResultsFiltered = data.filter(x => x.SearchResultType == "ed");

        for (let i = 0; i < educationResultsFiltered.length; i++) {
          let element = educationResultsFiltered[i];

          if (element.IsMatrixPost) {
            //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
            this.dotComService.checkIfImageExists(this.educationImagePaths + element.WebName + ".jpg", (exists) => {
              if (exists) {
                // Success code
                element.ImageName = this.educationImagePaths + element.WebName + ".jpg"
                this.educationResults.push(element);
                this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
              } else {
                // Fail code
                this.dotComService.checkIfImageExists(this.educationImagePaths + element.WebName + ".png", (exists) => {
                  if (exists) {
                    // Success code
                    element.ImageName = this.educationImagePaths + element.WebName + ".png"
                    this.educationResults.push(element);
                    this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                  } else {
                    // Fail code - use default
                    element.ImageName = this.baseImagePaths + "harrellsh.png"
                    this.educationResults.push(element);
                    this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                  }
                })
              }
            });
          }
          else {
            element.RevisionPublishDate = element.RevisionPublishDate.substring(0, element.RevisionPublishDate.indexOf(' ')).replace('1/1/9999', '');
            element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');

            //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
            this.dotComService.checkIfImageExists(this.blogImagePaths + element.WebName + ".jpg", (exists) => {
              if (exists) {
                // Success code
                element.ImageName = this.blogImagePaths + element.WebName + ".jpg"
                this.educationResults.push(element);
                this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
              } else {
                // Fail code
                this.dotComService.checkIfImageExists(this.blogImagePaths + element.WebName + ".png", (exists) => {
                  if (exists) {
                    // Success code
                    element.ImageName = this.blogImagePaths + element.WebName + ".png"
                    this.educationResults.push(element);
                    this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                  } else {
                    // Fail code - use default
                    element.ImageName = this.baseImagePaths + "harrellsh.png"
                    this.educationResults.push(element);
                    this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
                  }
                })
              }
            });
          }
        }
      })
    }
    else {
      if (this.dotComService.searchTerm.trim().length > 0) {
        this.searchSubmitted = true;
        this.displayFailureAlert = true;
        this.failureText = "Please enter a search term that is at least 3 characters long.";
      }
    }
  }

  ViewProductsDetail(product: any) {
    this.router.navigate(['/product'],
      { queryParams: { sku: product.ItemNmbr } })
  }

  GoToBlog(blog: any) {
    this.router.navigateByUrl('/blog?id=' + blog.WebName);
  }

  GoToEducationPostSearchPage(post?: any) {
    if (post.IsMatrixPost) {
      if (!this.loggedInUser || this.loggedInUser == '') {
        this.myHarrellsService.selectedCourse = post;
        this.myHarrellsService.courseIdToUse = post.Id;
        this.OpenLoginModal(post);
      }
      else {
        //this is a matrix post so we need to go to the matrix post page
        //go to the matrix platform to display the course - not using legacy education post for this one 
        this.myHarrellsService.courseAliasSelected = ""; //courseSelected.ItemAlias;
        this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = post.Id;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/matrix');
        });
      }
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/post'],
          { queryParams: { id: post.WebName } })
      });
    }
  }

  OpenPdfDoc(docType: string, id2: string) {
    this.myHarrellsService.GetPDFDocument(docType, id2).subscribe((response: any) => {
      if (response.length == 0) {
        this.displayFailureAlert = true;
        this.failureText = "There was an error retrieving the PDF document.  Please try again later.";
      }
      else {
        let PDFWindow = window.open(response[0].DocName, '_blank');
      }
    })
  }

  HideFailureAlert() {
    this.displayFailureAlert = false;
  }

  OpenSDSLabelModal() {
    this.sdsNotice = false;
    this.labelNotice = false;
    this.sdsNoticeModal = false;
    this.labelNoticeModal = false;
    this.metalNoticeModal = false;

    this.skuNumber = this.dotComService.searchTerm;
    document.getElementById("sdsLabelModal").style.display = "block";
  }

  CloseSDSLabelModal() {
    document.getElementById("sdsLabelModal").style.display = "none";
  }

  SKUChanged() {
    this.skuNumber = this.skuNumber.trim();

    this.productsSDS = (this.skuNumber.trim() == '') ? 'SEARCH FOR SDS' : "SEARCH FOR THE " + this.skuNumber.trim() + " SDS";
    this.productsLabel = (this.skuNumber.trim() == '') ? 'SEARCH FOR LABEL' : "SEARCH FOR THE " + this.skuNumber.trim() + " LABEL";
    this.productsMetal = (this.skuNumber.trim() == '') ? 'SEARCH FOR METAL' : "SEARCH FOR THE " + this.skuNumber.trim() + " METAL";
  }

  GetSDS(itemNmbr: string) {
    this.sdsNotice = false;
    this.sdsNoticeModal = false;
    this.dotComService.getDocument('sds', itemNmbr)
      .subscribe(response => {

        if (response && response.length > 0) {
          window.open(response[0].DocName, "_blank");
        } else {
          this.sdsNotice = true
          this.sdsNoticeModal = true
        }
      });
  }

  GetLabel(itemNmbr: string) {
    this.labelNoticeModal = false;
    this.dotComService.getDocument('label', itemNmbr)
      .subscribe(response => {

        if (response && response.length > 0) {
          window.open(response[0].DocName, "_blank");
        } else {
          this.labelNoticeModal = true
          this.labelNotice = true
        }
      });
  }

  GetMetal(itemNmbr: string) {
    this.metalNoticeModal = false;
    this.dotComService.getDocument('metal', itemNmbr)
      .subscribe(response => {

        if (response && response.length > 0) {
          window.open(response[0].DocName, "_blank");
        } else {
          this.metalNoticeModal = true
        }
      });
  }

  HideLabelNotFoundNotice() {
    this.labelNotice = false
    this.labelNoticeModal = false
  }

  HideSDSNotFoundNotice() {
    this.sdsNotice = false
    this.sdsNoticeModal = false
  }

  HideMetalNotFoundNotice() {
    this.metalNoticeModal = false
  }

  GoToRep(rep: any) {
    this.dotComService.GetAllReps(rep.Id).subscribe(reps => {
      if (reps.length == 0) {
        //the employee selected does not have a rep record - prob not a rep 
        return;
      }
      this.dotComService.repsMasterList = reps;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/rep'],
          { queryParams: { id: rep.Id } })

      });
    }
    )
  }

  OverLabelButton(isHovering: boolean) {
    this.isHovered = isHovering;
  }

  OpenLoginModal(course: any) {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = course.Id;
    document.getElementById("loginModal").style.display = "block";
  }

}
